import React from "react";

function ViewColor({ data }) {
  return (
    <div className="main_page">
      <div className="row g-3">

        {/* Color Name */}
        <div className="col-md-6">
          <label className="fw-semibold">Color Name</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.color_name || ""}
            readOnly
          />
        </div>

        {/* Color Code */}
        <div className="col-md-6">
          <label className="fw-semibold">Color Code</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.color_code || ""}
            readOnly
          />
        </div>

        {/* Color Hex */}
        <div className="col-md-6">
          <label className="fw-semibold">Color Hex</label>

          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                backgroundColor: data?.color_hex || "#ffffff",
              }}
            ></div>

            <input
              type="text"
              className="form-control custumform"
              value={data?.color_hex || ""}
              readOnly
            />
          </div>
        </div>

        {/* Sort Order */}
        <div className="col-md-6">
          <label className="fw-semibold">Sort Order</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.sort_order ?? "-"}
            readOnly
          />
        </div>

        {/* Category */}
        <div className="col-md-6">
          <label className="fw-semibold">Category</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.category_details?.name || "-"}
            readOnly
          />
        </div>

        {/* Sub Category */}
        <div className="col-md-6">
          <label className="fw-semibold">Sub Category</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.subcategory_details?.name || "-"}
            readOnly
          />
        </div>

        {/* Status */}
        <div className="col-md-6">
          <label className="fw-semibold">Status</label>
          <input
            type="text"
            className="form-control custumform"
            value={data?.status === 1 ? "Active" : "Inactive"}
            readOnly
          />
        </div>

        {/* Description */}
        <div className="col-md-12">
          <label className="fw-semibold">Description</label>
          <textarea
            rows={4}
            className="form-control custumform"
            value={data?.description || ""}
            readOnly
          />
        </div>

      </div>
    </div>
  );
}

export default ViewColor;